import { render, staticRenderFns } from "./ConfigMb.vue?vue&type=template&id=422a6e2c&scoped=true"
import script from "./ConfigMb.vue?vue&type=script&lang=js"
export * from "./ConfigMb.vue?vue&type=script&lang=js"
import style0 from "./ConfigMb.vue?vue&type=style&index=0&id=422a6e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a6e2c",
  null
  
)

export default component.exports